 const adventuresReducer = (state=[], action) => {
   switch (action.type) {
    case 'ADD_ADVENTURES':
      return action.payload
   case 'EDIT_ADVENTURE':
      return state.map(a=>{
        if(a.id===action.payload.id){return action.payload}
        return a
      })
   case 'DELETE_ADVENTURE':
      return state.filter(a=>a.id!==action.payload.id)
   default:
      return state
  }
}


export default adventuresReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/adventures.js